import Profile from '@/views/profile'
import ShowProfile from '@/views/profile/show'
import EditProfile from '@/views/profile/edit'
import ChangePassword from '@/views/profile/change-password'
export default {
  path: 'profile',
  redirect: '/profile/show',
  name: 'header.profile',
  component: Profile,
  children: [
    {
      path: 'show',
      name: 'header.profile',
      component: ShowProfile
    },
    {
      path: 'edit',
      name: 'user.message.edit',
      component: EditProfile
    },
    {
      path: 'change-password',
      name: 'user.message.change_password',
      component: ChangePassword
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/profiles/profile.js